import { ContactUsDto } from "types/dto";
import { ApiService } from "./apiService";
import { RequestDemoDto } from "types/dto/RequestDemoDto";



export const contactUs = async (payload: ContactUsDto) => {
  return await ApiService.post(`contacts`, payload);
}

export const requestDemo = async (payload: RequestDemoDto) => {
  return await ApiService.post(`demo_request`, payload);
}